<template>
    <div>
         <b-toast
            id="toast-error-account-information"
            variant="none"
            no-close-button
            toaster="b-toaster-top-center"
            >
            <img
                src="@/assets/img/ico-equis.png"
                style="margin-right: 10px; margin-top: -2px"
            />
            {{ message }}
		</b-toast>

          <b-toast
            id="toast-check-account-information"
            variant="none"
            no-close-button
            toaster="b-toaster-top-center"
            >
            	<img
			src="@/assets/img/ico-check.png"
			style="margin-right: 10px; margin-top: -2px"
		/>
            {{ message }}
		</b-toast>

        <div class="d-flex justify-content-between">
          <b-breadcrumb>
            <b-breadcrumb-item to="/student/account/information" >{{$t('account.mi-cuenta')}}</b-breadcrumb-item>
            <b-breadcrumb-item  active >{{$t('account.change-password')}}</b-breadcrumb-item>
          </b-breadcrumb>
          <div class="back-step mt-0"  @click="$router.go(-1)">
            <img class="svg" src="@/assets/icons/icon-arrow-left.svg">{{$t('planesYPrecios.regresar')}}
          </div>
        </div>
        <div class="card">
            
            <div class="card-body">
              <h6 class="sub-title"><span>{{$t('account.titulo')}}</span></h6>
              <b-row class="account-data">
                <b-col cols="6">
                  <b-form-group :label="$t('account.password-1')">
                    <b-form-input
                      type="password"
                      required
                     
                      v-model.trim="$v.groupPassword.currentPassword.$model"
                      v-bind:class="{ error: $v.groupPassword.currentPassword.$error}"
                    ></b-form-input>
                       <span class="error-input d-block">{{ validationMsgRegistro($v.groupPassword.currentPassword)}}</span>
                  </b-form-group>
                
                </b-col>
                <b-col cols="6" class="d-flex flex-column">
                   <b-form-group :label="$t('account.password-3')">
                    <b-form-input
                      type="password"
                      required
                     
                      v-model.trim="$v.groupPassword.newPassword.$model"
                        v-bind:class="{ error: $v.groupPassword.newPassword.$error}"
                      ></b-form-input>
                        <span class="error-input d-block">{{ validationMsgRegistro($v.groupPassword.newPassword)}}</span>
                    </b-form-group>
                  <b-form-group :label="$t('account.password-2')" class="mb-0"> 
                    <b-form-input
                      type="password"
                      required
                      
                      v-model.trim="$v.groupPassword.confirmPassword.$model"
                       v-bind:class="{ error: $v.groupPassword.confirmPassword.$error}"
                    ></b-form-input>
                       <span class="error-input d-block">{{ validationMsgRegistro($v.groupPassword.confirmPassword)}}</span>
                  </b-form-group>
                </b-col>
               
              </b-row>
               <div class="mt-4 d-flex justify-content-center">
                    <button
                      class="btn-primary btn-sm mt-2"
                      :disabled="$v.groupPassword.$invalid"
                      @click="$bvModal.show('modal-change-password')"
                    >
                      {{$t('account.button')}}
                    </button>
                  </div>
            </div>
        </div>

         <b-modal id="modal-change-password" 
          :hide-footer="false" 
          :hide-header="false"
          :hide-body="true" 
          :centered="true" 
          :no-close-on-esc="true">
          <template #modal-header="{ close }">
            <img class="close" src="@/assets/img/close_red.png" @click="close()">
          </template>
          <p class="text-center mb-0">{{$t('modals.modalConfirm.text-6')}}</p>
          <template #modal-footer>
            <b-button variant="danger" @click="$bvModal.hide('modal-change-password')">{{$t('modals.modalConfirm.button-cancel')}}</b-button>
           
            <b-button class="btn-primary" variant="primary" @click="changePassword"
              >
                <template v-if="!showSpinnerPassword">{{$t('modals.modalConfirm.text-4')}}</template>
                <b-spinner style="color:#ffffff;" v-else
               small></b-spinner>
            
            </b-button>
          </template>
        </b-modal>
    </div>
</template>
<script>

import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import * as Constants from "@/assets/js/appConstants";
import { horarioObtenerColorClase, openLinkClass } from '@/assets/js/util.js';
import {
  required,
  sameAs,
  maxLength
} from "vuelidate/lib/validators";
import { validationMessage } from 'vuelidate-messages';
const formMessagesLogin = { 
    required: function (){
        return this.$t('validations.formMessagesLogin.required')
    },
    sameAsPassword:function (){
        return this.$t('validations.formRegisterMessages.sameAsPassword')
    },
    strongPassword:function (){
        return this.$t('validations.formRegisterMessages.strongPassword')
    },
    noWhitespaces:function (){
        return this.$t('validations.formRegisterMessages.noWhitespacesPassword')
    },
    maxLength:function ({ $params }){
        return `${this.$t('validations.formRegisterMessages.maxLength.1')} ${$params.maxLength.max } ${this.$t('validations.formRegisterMessages.maxLength.2')}`
    }

};



export default {
    data(){
        return{
            message: '',
            showSpinnerPassword:false,
            groupPassword: {
                currentPassword: "",
                newPassword: "",
                confirmPassword: ""
            },
        }
    },
    computed: {
        groupId:{
            get() {
                return this.$store.state.group_id;
            },
            set(value) {
                this.$store.commit("mutateGroupId", value);
            } 
            },
        User: {
            get() {
                return this.$store.state.user;
            },
        }
    },
    validations: {
 
        groupPassword: {
            currentPassword: {
                required
            },
            newPassword: {
                required,
                maxLengthPassword: maxLength(20),
                strongPassword(newPassword) {
                    return (
                        /[a-z]/.test(newPassword) && // condición minúscula (a-z)
                        /[A-Z]/.test(newPassword) && // condición mayúscula  (A-Z)
                        /[0-9]/.test(newPassword) && // condición número (0-9)
                        /\W|_/.test(newPassword) && // condición símbolo
                        newPassword.length >= 6
                    );
                },
                noWhitespacesPassword(newPassword) {
                    return !/["/ +/"]/.test(newPassword); // condición no espacios en blanco
                }
            },
            confirmPassword: {
                required,
                sameAsPassword: sameAs("newPassword")
            }
        }
    },

  created(){
     
	},
	mounted(){

	},
    methods: {
        validationMsgRegistro: validationMessage(formMessagesLogin),
        changePassword(){
            this.showSpinnerPassword  = true;
            let json = {
              id: this.User.id,
              Password: this.groupPassword.newPassword,
              LastPassword: this.groupPassword.currentPassword
            }
       
             baseInstanceAxios
                .post(`${this.apiURL}/resources/Persons/SavePasswordDirect`, json)
                .then(response => {
                           
                            this.nextStep = false;
                            if(response.data.value == 0){
                                this.message = this.$t('my-cours.person-not-exist');
                                this.$bvToast.show("toast-error-account-information");
                            }

                            if(response.data.value == 1){
                               this.message = this.$t('my-cours.current-password-incorrect');
                                this.$bvToast.show("toast-error-account-information");

                            }

                            if(response.data.value == 2){
                                this.message = this.$t('reusables.password-was-changed');
                                this.$bvToast.show("toast-check-account-information");
                                this.groupPassword = {
                                    currentPassword: "",
                                    newPassword: "",
                                    confirmPassword: ""
                                };
                                this.$v.$reset()
                            
                            }
                            this.$bvModal.hide('modal-change-password');
                            this.showSpinnerPassword  = false;
                })
                .catch(error => {
                    this.message = this.$t('my-cours.mesage-system-error');
                    this.$bvToast.show("toast-error-account-information");
                    this.showSpinnerPassword = false;
                });
        }
	}
}
</script>